if (!customElements.get('nr-shield-film')) {
  customElements.define('nr-shield-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.control = this.querySelector('button');
      if (!this.video) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.inView = false;
      if (this.control) this.control.hidden = false;
      this.video.muted = true;
      this.updateControl = () => {
        if (this.control) this.control.textContent = this.video.paused ? this.control.dataset.playLabel : this.control.dataset.pauseLabel;
      };
      this.video.addEventListener('playing', () => {
        if (this.userPaused) {
          this.video.pause();
          return;
        }
        this.classList.add('has-video');
        this.updateControl();
      }, options);
      this.video.addEventListener('pause', this.updateControl, options);
      this.video.addEventListener('error', () => {
        this.classList.remove('has-video');
        if (this.control) this.control.hidden = true;
      }, options);
      this.control?.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.autoplay = false;
          this.video.pause();
        }
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) {
          this.video.autoplay = false;
          this.video.pause();
          this.classList.remove('has-video');
        } else if (this.inView && !this.userPaused && !document.hidden) {
          this.play();
        }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else if (this.inView && !this.motion.matches && !this.userPaused) this.play();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (!this.inView) this.video.pause();
        else if (!this.motion.matches && !this.userPaused && !document.hidden) this.play();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.updateControl();
    }
    async play() {
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.autoplay = !this.motion.matches;
      try { await this.video.play(); } catch { this.updateControl(); }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
    }
  });
}
